var exports = {
  "Q": "ChannelDuplicateModal.module__content___eURmdz",
  "c": "ChannelDuplicateModal.module__helperText___eURmdz",
};

module.exports = exports;
